import React, { useEffect, useState } from "react";
import axios from "axios";
const ENV_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const API = `${ENV_API_BASE_URL}/api/home-retreat-section`;

const DEFAULT_FORM = {
  title: "Yoga Meditation Retreat",
  highlightText: "in Rishikesh",
  description:
    "Elevate your life with an unforgettable yoga retreat experience. Discover and book rejuvenating yoga retreats, vacations, and yoga teacher training courses at Hatha Yogashram",
};

export default function RetreatSectionAdmin() {
  const [form, setForm] = useState(DEFAULT_FORM);
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(API)
      .then((res) => {
        if (res.data?.data) {
          setForm({
            title: res.data.data.title || DEFAULT_FORM.title,
            highlightText: res.data.data.highlightText || DEFAULT_FORM.highlightText,
            description: res.data.data.description || DEFAULT_FORM.description,
          });
        }
      })
      .catch((err) => {
        console.error("Failed to load retreat section:", err);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSaved(false);
    setError("");

    try {
      await axios.put(API, form);
      setSaved(true);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to save retreat section.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container pt-5 mt-5" style={{ maxWidth: 900 }}>
      <h3 className="mb-1">Retreat Section</h3>
      <p className="text-muted small mb-4">
        Edit the homepage retreat section heading and description. Retreat cards come from the
        course catalog where `homeSections` includes `retreat`.
      </p>

      {error && <div className="alert alert-danger">{error}</div>}
      {saved && <div className="alert alert-success">Retreat section saved successfully.</div>}

      <form onSubmit={handleSubmit} className="card p-4 shadow-sm">
        <div className="row">
          <div className="col-md-8 mb-3">
            <label className="form-label">Title</label>
            <input
              type="text"
              name="title"
              className="form-control"
              value={form.title}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">Highlighted Text</label>
            <input
              type="text"
              name="highlightText"
              className="form-control"
              value={form.highlightText}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Description</label>
          <textarea
            name="description"
            className="form-control"
            rows={4}
            value={form.description}
            onChange={handleChange}
          />
        </div>

        <div className="alert alert-info py-2 small mb-4">
          Manage retreat cards from the course catalog. For each retreat course, set
          `homeSections` to include `retreat` and fill the Retreat Card fields.
        </div>

        <div className="d-flex justify-content-end">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Saving..." : "Save Retreat Section"}
          </button>
        </div>
      </form>
    </div>
  );
}
